import ApiBase from '@/api/base';

export default {
  getOpportunityCustomFields (args) {
    return ApiBase.get(`/user/opportunity_custom_fields`);
  },
  createOpportunityCustomField (args) {
    return ApiBase.post(`/user/opportunity_custom_fields`, args);
  },
  deleteOpportunityCustomField (args) {
    const { opportunityCustomFieldId } = args;
    return ApiBase.delete(`/user/opportunity_custom_fields/${opportunityCustomFieldId}`, args);
  },
  // 単体での更新
  updateOpportunityCustomField (args) {
    const { opportunityCustomFieldId } = args;
    return ApiBase.put(`/user/opportunity_custom_fields/${opportunityCustomFieldId}`, args);
  },
  // 一括更新
  updateOpportunityCustomFields (args) {
    return ApiBase.put(`/user/opportunity_custom_fields`, args);
  },
  deleteOpportunityCustomFieldOption (args) {
    const { opportunityCustomFieldOptionId } = args;
    return ApiBase.delete(`/user/opportunity_custom_field_options/${opportunityCustomFieldOptionId}`, args);
  },
};
